<template>
  <div class="real-time-step-list-dialog">
    <div class="dialog-header">
      <div class="header-info">
        <h3 class="dialog-title">实时评审进度查看</h3>
        <div class="header-details">
          <span>标段编号:{{ bidSectionCode }}</span>
        </div>
      </div>
      <div class="header-controls">
        <el-button type="primary" :icon="isRealTime ? 'el-icon-video-pause' : 'el-icon-video-play'"
          @click="toggleRealTime" size="small">
          {{ isRealTime ? '关闭实时查看' : '开启实时查看' }}
        </el-button>
      </div>
    </div>

    <div class="table-container">
      <el-table :data="stepList" style="width: 100%" stripe border>
        <el-table-column label="序号" width="60" align="center" type="index" />
        <el-table-column prop="nodeName" label="节点名称" min-width="150" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.stepName }}
          </template>
        </el-table-column>
        <el-table-column prop="nodeType" label="节点类型" min-width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.stepTypeName }}
          </template>
        </el-table-column>
        <el-table-column prop="reviewStatus" label="评审状态" min-width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.finished === 0 ? '正在评审' : '评审结束' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.finished === 1" type="primary" size="small" @click="viewResultDetail(scope.row)">
              查看评审结果
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 评审结果详情对话框 -->
    <el-dialog title="评审结果" :visible.sync="resultDialogVisible" width="60%" @close="handleResultDialogClose"
      append-to-body>

      <div class="dialog-content">
        <!-- 节点信息 -->
        <div class="node-section">
          <span class="label">节点名称：</span>
          <span>{{ currentStep.stepName || '--' }}</span>
          <el-tag :type="currentStep.finished === 1 ? 'success' : 'warning'" size="small" style="margin-left: 10px;">
            {{ currentStep.finished === 1 ? '已结束' : '进行中' }}
          </el-tag>
        </div>
        <div class="node-section">
          <span class="label">标段编号: </span>
          <span>{{ currentStep.bidSectionCode || '--' }}</span>
        </div>

        <!-- HTML内容展示 -->
        <div class="html-section" v-if="currentStep && currentStep.stepResultHtmlContent">
          <div class="html-content" v-html="currentStep.stepResultHtmlContent"></div>
        </div>

        <div v-else class="no-data">
          暂无内容
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleResultDialogClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import realTimeReviewApi from '@/api/stepRealTimeReview/api.js'
export default {
  name: 'RealTimeStepListDialog',
  props: {
    bidSectionCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      stepList: [],
      isRealTime: false,
      refreshTimer: null,
      isLoading: false,
      resultDialogVisible: false,
      currentStep: {}  // 当前选中的评审节点
    }
  },
  created() {
    this.loadStepList()
  },
  beforeDestroy() {
    this.stopCountdown()
  },
  methods: {
    async loadStepList() {
      this.isLoading = true;
      console.log('开始请求，参数：', this.bidSectionCode);
      try {
        const response = await realTimeReviewApi.getReviewResultList(this.bidSectionCode);
        console.log('请求成功，响应：', response);
        if (response.code === 200) {
          this.stepList = response.data;
        } else {
          this.$message.error('获取数据失败，' + response.msg);
        }
      } catch (error) {
        console.error('获取列表失败:', error);
        this.$message.error('获取列表失败');
      } finally {
        this.isLoading = false;
      }
    },

    // 切换实时查看状态
    toggleRealTime() {
      if (this.isRealTime) {
        this.stopRealTimeRefresh()
      } else {
        this.startRealTimeRefresh()
      }
    },

    startRealTimeRefresh() {
      if (this.isRealTime) return;
      this.isRealTime = true;
      this.loadStepList();
      this.refreshTimer = setInterval(() => {
        this.loadStepList();
      }, 5000)
    },

    stopRealTimeRefresh() {
      this.isRealTime = false;
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },

    // 查看评审结果详情
    async viewResultDetail(row) {
      console.log('查看评审结果:', row);
      try {
        const response = await realTimeReviewApi.getReviewResultDetail({
          stepId: row.id,
          bidSectionId: row.bidSectionCode,
          stepTypeCode: row.stepTypeCode
        });
        if (response.code === 200) {
          console.log(response.data)
          this.currentStep = {
            stepName: response.data.stepName || row.stepName,
            finished: response.data.finished || row.finished,
            stepTypeName: response.data.stepTypeName || row.stepTypeName,
            bidSectionCode: response.data.bidSectionCode || row.bidSectionCode,
            stepResultHtmlContent: response.data.htmlContent
          }
        } else {
          this.$message.error('获取评审结果内容失败, ' + response.msg)
        }

      } catch (error) {
        console.error('获取评审结果失败:', error);
        this.currentStep.reviewResult = null;
      }

      this.resultDialogVisible = true;
    },

    handleResultDialogClose() {
      this.resultDialogVisible = false;
      this.currentStep = {};
    },


    stopCountdown() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
        this.refreshTimer = null
      }
    },

  }
}
</script>
<style scoped>
.real-time-step-list-dialog {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.dialog-header {
  padding: 15px 20px;
  background: #f5f7fa;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.dialog-title {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.header-details {
  margin-top: 5px;
  font-size: 12px;
  color: #666;
}

.header-details span {
  margin-right: 15px;
}

.header-controls {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.table-container {
  flex: 1;
  overflow: hidden;
}

::v-deep .el-table {
  height: 100% !important;
}

/* 评审结果对话框内容样式 */
.review-result-content {
  max-height: 60vh;
  overflow-y: auto;
  padding: 10px 5px;
}

.review-result-content h4 {
  margin: 15px 0 10px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
  color: #303133;
  font-size: 15px;
}

.result-info,
.result-details {
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.info-item,
.detail-item {
  display: flex;
  margin-bottom: 12px;
  line-height: 1.5;
}

.info-item:last-child,
.detail-item:last-child {
  margin-bottom: 0;
}

.info-item .label,
.detail-item .label {
  min-width: 100px;
  color: #606266;
  font-weight: 500;
}

.info-item .value,
.detail-item .value {
  flex: 1;
  color: #303133;
}

.no-data {
  text-align: center;
  padding: 30px 0;
  color: #909399;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .dialog-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .header-controls {
    margin-top: 10px;
    width: 100%;
  }

  .info-item,
  .detail-item {
    flex-direction: column;
  }

  .info-item .label,
  .detail-item .label {
    margin-bottom: 5px;
    min-width: auto;
  }
}

/* 对话框自定义样式 - 这里必须使用全局样式 */
::v-deep .review-result-dialog {
  /* 控制对话框位置，可以调高top值让它往下显示 */
  margin-top: 8vh !important;

  /* 提高z-index确保在最上层 */
  z-index: 9999 !important;
}

::v-deep .review-result-dialog .el-dialog {
  position: relative;
  z-index: 9999;
}

::v-deep .review-result-dialog .el-dialog__header {
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
  background: #f5f7fa;
}

::v-deep .review-result-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

::v-deep .review-result-dialog .el-dialog__body {
  padding: 20px;
}

::v-deep .review-result-dialog .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}
</style>

<!-- 全局样式，如果需要进一步控制层叠 -->
<style>
/* 如果还有层叠问题，可以在App.vue或全局样式文件中添加 */
.el-dialog__wrapper {
  z-index: 9999 !important;
}

.review-result-dialog {
  z-index: 9999 !important;
}

.dialog-content {
  padding: 20px;
}

.node-section {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.label {
  color: #666;
  font-weight: 500;
}

.html-section {
  min-height: 200px;
  max-height: 400px;
  overflow-y: auto;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 4px;
}

.no-data {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

.html-content {
  line-height: 1.5;
}
</style>
